import { render } from "./IconPatientsSimple.vue?vue&type=template&id=0676c670"
import script from "./IconPatientsSimple.vue?vue&type=script&lang=js"
export * from "./IconPatientsSimple.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__